import './navigation'
import './main.scss'
import animateScrollTo from 'animated-scroll-to'
import { setPlayerCurrentTime } from '~/common/components/videojs/helpers'

document.addEventListener('DOMContentLoaded', function () {
  // wait for the player to be ready, otherwise player is undefined
  document.addEventListener('simplero:media:ready', function (e) {
    let mediaWrapper = e.target.closest('.course-lesson__asset')

    if (!mediaWrapper) {
      mediaWrapper = e.target.closest('.course-lesson__attachment__embed')
    }

    const media = e.target

    if (!media || !mediaWrapper) {
      return false
    }

    const player = window.videojs.getPlayer(media.id)

    // *** Transcription
    const transcriptOpener = mediaWrapper.querySelector('.transcript__opener')
    const transcriptWrapper = mediaWrapper.querySelector('.transcript__wrapper')

    if (transcriptOpener && transcriptWrapper) {
      transcriptOpener.addEventListener('click', (event) => {
        event.stopPropagation()
        event.preventDefault()

        transcriptWrapper.classList.toggle('transcript--closed')
        transcriptOpener.classList.toggle('transcript__opener--open')
      })

      // by default, the scroll will be automatic. If user manually scrolls, set to false till he clicks the return button
      let autoScroll = true
      let highlightedText

      const sentences = transcriptWrapper.querySelectorAll('.sentence__wrapper')

      player.on('timeupdate', function () {
        // if the transcript wrapper is not open, don't bother
        const currentTranscriptWrapper = mediaWrapper.querySelector(
          '.transcript__wrapper'
        )
        if (
          !currentTranscriptWrapper.classList.contains('transcript--closed')
        ) {
          const currentTime = player.currentTime()

          sentences.forEach(function (text) {
            const start = parseFloat(text.getAttribute('data-start-time'))
            const end = parseFloat(text.getAttribute('data-end-time'))
            if (currentTime >= start && currentTime <= end) {
              if (highlightedText && highlightedText != text) {
                // Remove highlight from any sentence that had it only when a new one is about to be highlighted
                highlightedText.classList.remove('highlighted__text')
              }
              text.classList.add('highlighted__text')
              highlightedText = text
            }
          })

          // auto scroll
          let transcriptDiv = mediaWrapper.querySelector('.paragraphs__wrapper')

          if (!transcriptDiv || !highlightedText) {
            return
          }

          // buttons for when user scrolls far from current text
          const returnButton = mediaWrapper.querySelector('.transcript__return')

          const transcriptDivPosition = transcriptDiv.offsetTop
          const currentTextPosition = highlightedText.offsetTop
          const distance = currentTextPosition - transcriptDivPosition

          const currentTranscriptDivScrollValue = transcriptDiv.scrollTop
          const transcriptDivHeight = transcriptDiv.clientHeight
          const transcriptDivBottom =
            currentTranscriptDivScrollValue + transcriptDivHeight

          const textIsAbove =
            currentTextPosition < currentTranscriptDivScrollValue
          const textIsBelow = currentTextPosition > transcriptDivBottom

          if (textIsAbove || textIsBelow) {
            // highlighted text is outside the scroll view
            if (autoScroll) {
              animateScrollTo(distance - 25, {
                elementToScroll: transcriptDiv,
              })
            } else {
              returnButton.classList.remove('transcript__return--hide')

              if (textIsAbove) {
                returnButton.classList.add('transcript__return--up')
                returnButton.classList.remove('transcript__return--down')
              } else {
                returnButton.classList.add('transcript__return--down')
                returnButton.classList.remove('transcript__return--up')
              }
            }
          } else {
            returnButton.classList.add('transcript__return--hide')
          }

          returnButton.addEventListener('click', (e) => {
            autoScroll = true
            animateScrollTo(distance - 25, {
              elementToScroll: transcriptDiv,
            })
            returnButton.classList.add('transcript__return--hide')
          })

          // Detect user manual scroll and disable autoScroll. Turn it back on after 15 seconds.
          function turnOnAutoScroll() {
            autoScroll = true
          }

          let scrollTimeout
          ;['touchstart', 'wheel', 'scroll'].forEach((event) => {
            transcriptDiv.addEventListener(event, () => {
              autoScroll = false
              clearTimeout(scrollTimeout)
              scrollTimeout = setTimeout(turnOnAutoScroll, 15000)
            })
          })
        }
      })

      //if a sentence is clicked, visit current time on player
      sentences.forEach((text) => {
        text.addEventListener('click', () => {
          // remove highlight from any sentence that had it
          const currentHighlightedText =
            transcriptWrapper.querySelector('.highlighted__text')
          if (currentHighlightedText) {
            currentHighlightedText.classList.remove('highlighted__text')
          }

          // add highlight to clicked line
          text.classList.add('highlighted__text')

          const startTime = parseFloat(text.getAttribute('data-start-time'))
          setPlayerCurrentTime(player, startTime)
          autoScroll = true
        })
      })
    }

    // *** Bookmarks
    const bookmarkRows = mediaWrapper.querySelectorAll('.bookmark__row')
    bookmarkRows.forEach((bookmark) => {
      bookmark.addEventListener('click', (e) => {
        e.preventDefault()
        setPlayerCurrentTime(player, bookmark.getAttribute('data-start-time'))
      })
    })
  })
})
